<script setup>
import ModalBox from './ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	modalId: {
		type: String,
		default: 'modal-alert',
	},
	message: {
		type: String,
		required: true,
	},
	body: {
		type: String,
		required: false,
	},
	// Short context for assistive tech (callers pass e.g. "Access required");
	// declared so it stops falling through to ModalBox's fragment root.
	description: {
		type: String,
		default: '',
	},
	okText: {
		type: String,
		default: 'Yes',
	},
	buttonAlignment: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['modal-confirm'])

const { isVisible, hide } = useLegacyModalBridge(() => props.modalId)

const onConfirm = () => {
	emit('modal-confirm')
	hide()
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		size="sm"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
	>
		<div class="px-6 py-4 border-b border-surface-3">
			<p v-if="description" class="sr-only">{{ description }}</p>
			<h3 class="m-0 text-base font-medium text-surface-text-2">
				{{ message }}
			</h3>
		</div>
		<div class="px-6 py-5 text-surface-7 text-sm leading-relaxed">
			<template v-if="body">{{ body }}</template>
			<slot />
		</div>
		<template #footer>
			<div :class="[buttonAlignment, 'flex px-6 pb-6 pt-0 justify-end']">
				<FormButton size="md" @click="onConfirm">
					{{ okText }}
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
